import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-10 px-6 text-center border-t border-white/5 bg-[#0F0F14] mb-16 md:mb-0" data-id="element-39">
        <p className="text-[#A8A8B3]/40 text-sm mb-3" data-id="element-40">
          © {new Date().getFullYear()} No Contact, Sin Recaídas.
        </p>
        <div className="flex items-center justify-center gap-4 text-sm" data-id="element-41">
          <button onClick={() => setActiveModal('privacy')} className="text-[#A8A8B3]/50 hover:text-[#A8A8B3] transition-colors duration-200" data-id="element-42">
            Política de Privacidad
          </button>
          <span className="text-[#A8A8B3]/20" data-id="element-43">·</span>
          <button onClick={() => setActiveModal('terms')} className="text-[#A8A8B3]/50 hover:text-[#A8A8B3] transition-colors duration-200" data-id="element-44">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-45">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8" onClick={() => setActiveModal(null)} data-id="element-46">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-47" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          type: 'spring',
          bounce: 0.2
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto glass-card rounded-2xl p-6 md:p-10 z-10 bg-[#1A1A24] border border-white/10" data-id="element-48">
              {/* Close Button */}
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 p-2 rounded-full hover:bg-white/10 transition-colors text-[#A8A8B3] hover:text-white" data-id="element-49">
                <XIcon className="w-5 h-5" data-id="element-50" />
              </button>

              {activeModal === 'privacy' ? <PrivacyContent data-id="element-51" /> : <TermsContent data-id="element-52" />}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div className="space-y-6 text-[#A8A8B3] leading-relaxed text-sm" data-id="element-53">
      <h2 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-54">
        Política de Privacidad
      </h2>

      <p data-id="element-55">Última actualización: Febrero 2026</p>

      <div className="space-y-4" data-id="element-56">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-57">
          1. Información que recopilamos
        </h3>
        <p data-id="element-58">
          Al realizar una compra, recopilamos únicamente la información
          necesaria para procesar tu pedido: dirección de correo electrónico y
          datos de pago (procesados de forma segura por nuestro proveedor de
          pagos).
        </p>
      </div>

      <div className="space-y-4" data-id="element-59">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-60">
          2. Uso de la información
        </h3>
        <p data-id="element-61">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-2" data-id="element-62">
          <li data-id="element-63">Entregar el producto digital adquirido</li>
          <li data-id="element-64">Enviar confirmación de compra</li>
          <li data-id="element-65">Brindarte soporte si lo solicitas</li>
        </ul>
        <p data-id="element-66">
          No vendemos, compartimos ni alquilamos tu información personal a
          terceros.
        </p>
      </div>

      <div className="space-y-4" data-id="element-67">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-68">
          3. Protección de datos
        </h3>
        <p data-id="element-69">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Los pagos son procesados a través de
          plataformas seguras con encriptación SSL.
        </p>
      </div>

      <div className="space-y-4" data-id="element-70">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-71">
          4. Cookies
        </h3>
        <p data-id="element-72">
          Este sitio puede utilizar cookies esenciales para el funcionamiento
          básico y cookies analíticas para entender cómo los visitantes
          interactúan con la página. No utilizamos cookies de seguimiento
          publicitario.
        </p>
      </div>

      <div className="space-y-4" data-id="element-73">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-74">
          5. Tus derechos
        </h3>
        <p data-id="element-75">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento.
        </p>
      </div>

      <div className="space-y-4" data-id="element-76">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-77">
          6. Cambios a esta política
        </h3>
        <p data-id="element-78">
          Nos reservamos el derecho de actualizar esta política. Cualquier
          cambio será publicado en esta página con la fecha de actualización
          correspondiente.
        </p>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6 text-[#A8A8B3] leading-relaxed text-sm" data-id="element-79">
      <h2 className="text-2xl font-heading font-bold text-white mb-6" data-id="element-80">
        Términos y Condiciones
      </h2>

      <p data-id="element-81">Última actualización: Febrero 2026</p>

      <div className="space-y-4" data-id="element-82">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-83">
          1. Producto digital
        </h3>
        <p data-id="element-84">
          "No Contact, Sin Recaídas" es un producto digital (ebook + journal
          guiado en formato PDF) diseñado como herramienta de bienestar
          emocional. No constituye terapia psicológica, asesoramiento médico ni
          tratamiento profesional de salud mental.
        </p>
      </div>

      <div className="space-y-4" data-id="element-85">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-86">
          2. Entrega
        </h3>
        <p data-id="element-87">
          El producto se entrega de forma digital e inmediata tras la
          confirmación del pago. Recibirás un enlace de descarga en tu correo
          electrónico.
        </p>
      </div>

      <div className="space-y-4" data-id="element-88">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-89">
          3. Uso personal
        </h3>
        <p data-id="element-90">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, reventa o compartición
          del material sin autorización expresa.
        </p>
      </div>

      <div className="space-y-4" data-id="element-91">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-92">
          4. Política de reembolso
        </h3>
        <p data-id="element-93">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se ofrecen reembolsos una vez completada la descarga. Si tienes
          problemas técnicos con la descarga, contáctanos y te ayudaremos a
          resolverlo.
        </p>
      </div>

      <div className="space-y-4" data-id="element-94">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-95">
          5. Descargo de responsabilidad
        </h3>
        <p data-id="element-96">
          Este producto es una herramienta de apoyo emocional y no sustituye la
          atención profesional. Si estás en una situación de crisis, abuso o
          peligro, te recomendamos buscar ayuda profesional especializada de
          inmediato.
        </p>
        <p data-id="element-97">
          Los resultados pueden variar según cada persona. No garantizamos
          resultados específicos.
        </p>
      </div>

      <div className="space-y-4" data-id="element-98">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-99">
          6. Propiedad intelectual
        </h3>
        <p data-id="element-100">
          Todo el contenido, diseño, textos y materiales de "No Contact, Sin
          Recaídas" están protegidos por derechos de autor. Todos los derechos
          reservados.
        </p>
      </div>

      <div className="space-y-4" data-id="element-101">
        <h3 className="text-lg font-heading font-bold text-white" data-id="element-102">
          7. Modificaciones
        </h3>
        <p data-id="element-103">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor desde su publicación en esta
          página.
        </p>
      </div>
    </div>;
}